import React, { Component } from 'react';
import ColorPicker from './Customize/ColorPicker.js';

class CustomizePage extends Component {

    constructor(props) {
        super(props);
        const userData = this.getUserData();
        this.state = { 
            stats: userData,
            newCustomization: {},
            usedPoints: 0,
        };
        
        this.setNewStat = this.setNewStat.bind(this);
        this.saveConfig = this.saveConfig.bind(this);
    }

    getUserData() {
        return {
            username: window.loginController.loginCache.token.user_name,
            availablePoints: 123,
            customization: []
        };
    }

    setNewStat(stat) {
        this.setState({
            newCustomization: Object.assign(this.state.newCustomization, stat)
        }, this.recalculatePoints)
    }

    recalculatePoints() {
        let usedPoints = 0;
        for (const [key, value] of Object.entries(this.state.newCustomization)) {
            usedPoints += value.cost;
        }

        this.setState({
            usedPoints
        });
    }

    saveConfig() {
        // Make post request for the proposed changes...
        // ON FAILURE
        // return with an alert
        

        // ON SUCCESS:
        let newStats = this.state.stats;
        newStats.availablePoints -= this.state.usedPoints;
        this.setState({
            stats: Object.assign(this.state.stats, newStats),
            newCustomization: {}
        }, this.recalculatePoints)
    }

    render() {
        return (
            <div className="mb-page">
                <div className="mb-header mb-page-header no-bg">
                    Available Points: {this.state.stats.availablePoints}
                    <br/>Remaining points: {this.state.stats.availablePoints - this.state.usedPoints}
                </div>
                <div className="mb-page-row">
                    <div>
                        Marble Color
                    </div>
                    <ColorPicker
                        callback={this.setNewStat}
                        colors={[
                            'white',
                            'red',
                            'orange',
                            'yellow',
                            'green',
                            'blue',
                            'black',
                            ]} />
                </div>

                <div className="mb-page-row last-row">
                    <button
                        onClick={this.saveConfig}
                        className="button-save"
                    >Save
                    </button>
                    <div className="small">Warning: Changing marble settings will use your points EVERY TIME</div>
                </div>
            </div>
        )
    }
}

export default CustomizePage;


// WEBPACK FOOTER //
// ./src/CustomizePage.js